export var NO_ENTITY_RESULTS = {
  meta: {
    count: 0,
    total: 0
  },
  results: []
};